import dayjs from "dayjs";
import React from "react";

import Icon       from "_components/atoms/icon";
import Typography from "_components/atoms/typography";

import "dayjs/locale/en";

import useStyles from "./styles";

const formattedDate = nextApprovalDate => {
	const date          = dayjs ( nextApprovalDate ).locale ( "en" );
	const formattedDate = date.format ( "DD MMM, YYYY" );

	return formattedDate;
};
const StepperHeader = ( { title, currentStep, totalSteps, showApprovalDate, nextApprovalDate, isRejected, subTitle, isCompleted } ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.headerWrapper }>
			<div className = { classes.header }>
				{!isRejected && (
					<Icon
						className = { classes.headerIcon }
						name      = { isCompleted ? "watchComplete" : "watchIncomplete" }
					/>
				)}

				{isRejected && (
					<Icon
						sameInBothTheme
						className = { classes.headerIcon }
						name      = { "watchRejected" }
					/>
				)}

				<div className = { classes.headerInfo }>

					<Typography
						className = { classes.headerStep }
						title     = { `Step ${ currentStep + 1 }/${ totalSteps } ` }
					/>

					<p>
						<span className = { classes.headerTitle }>
							{title}
						</span>

						{" "}
            &nbsp;
						{" "}

						{showApprovalDate && (
							<span className = { classes.headerStep }>
								{formattedDate ( nextApprovalDate )}
							</span>
						)}
					</p>
				</div>
			</div>

			{subTitle && (
				<Typography
					className = { classes.headerSubtitle }
					title     = { subTitle }
				/>
			)}
		</div>
	);
};

export default StepperHeader;
